import { render, staticRenderFns } from "./menuCatalogList.vue?vue&type=template&id=4a8a1c1a&scoped=true"
import script from "./menuCatalogList.vue?vue&type=script&lang=js"
export * from "./menuCatalogList.vue?vue&type=script&lang=js"
import style0 from "./menuCatalogList.vue?vue&type=style&index=0&id=4a8a1c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8a1c1a",
  null
  
)

export default component.exports